import { useRef } from 'react';

export default function usePeerNetworkStatusListener(roomId, socket) {
  const reportStatusRestoredRef = useRef();

  async function reportNetworkStatus(status, restoreAfterTimeout = true) {
    if (!socket) return;

    if (restoreAfterTimeout && reportStatusRestoredRef.current) {
      clearTimeout(reportStatusRestoredRef.current);
      reportStatusRestoredRef.current = null;
    }

    await socket.request('networkStatus', status);

    if (!restoreAfterTimeout) return;

    reportStatusRestoredRef.current = setTimeout(() => {
      reportNetworkStatus(4, false);
    }, 5000);
  }

  return { reportNetworkStatus };
}
